module.exports = __webpack_public_path__ + "static/media/pic1.4f9c0210.jpg";